import React, { useState } from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Printer, Home, Building2, CheckCircle2 } from 'lucide-react';
import { SERVICE_INSTRUCTIONS, instructionsHTML } from '../../lib/companyPolicies';
import { printHTML } from '../../lib/importExport';
import { useConfig } from '../../context/ConfigContext';

const PESTS = Object.keys(SERVICE_INSTRUCTIONS);

export default function ServiceInstructions() {
  const [pest, setPest] = useState(PESTS[0]);
  const [kind, setKind] = useState('home');
  const { contact } = useConfig();
  const d = SERVICE_INSTRUCTIONS[pest];

  const List = ({ title, items }) => (
    <div>
      <h3 className="font-bold text-slate-900 mb-2">{title}</h3>
      <ul className="space-y-2">
        {items.map((x, i) => (
          <li key={i} className="flex gap-2 text-sm text-slate-700"><CheckCircle2 className="w-4 h-4 text-[#8dd110] flex-shrink-0 mt-0.5" />{x}</li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="p-6 lg:p-8 space-y-5">
      <div className="flex justify-between items-center flex-wrap gap-3">
        <div>
          <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">Service Instructions</h1>
          <p className="text-slate-500 mt-1">Before &amp; after prep sheets to send or hand to customers — by pest and property type.</p>
        </div>
        <Button onClick={() => printHTML(instructionsHTML(pest, kind, contact))} className="bg-[#8dd110] hover:bg-[#71a80f] gap-1.5"><Printer className="w-4 h-4" />Print / PDF</Button>
      </div>

      <div className="flex flex-wrap gap-2">
        {PESTS.map((p) => (
          <button key={p} onClick={() => setPest(p)} className={`px-3.5 py-2 rounded-lg text-sm font-semibold border ${pest === p ? 'border-[#8dd110] bg-[#8dd110]/10 text-[#5b8523]' : 'border-slate-200 text-slate-600 hover:border-slate-300'}`}>{p}</button>
        ))}
      </div>

      <div className="flex gap-2">
        {[['home', Home, 'Home'], ['business', Building2, 'Business']].map(([k, Ico, label]) => (
          <button key={k} onClick={() => setKind(k)} className={`flex items-center gap-1.5 px-4 h-10 rounded-md border text-sm font-semibold ${kind === k ? 'border-[#8dd110] bg-[#8dd110]/10 text-[#71a80f]' : 'border-slate-200 text-slate-600'}`}><Ico className="w-4 h-4" />{label}</button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        <Card className="p-6 border-slate-200"><List title="Before Your Service" items={d.pre} /></Card>
        <Card className="p-6 border-slate-200"><List title="After Your Service" items={d.post} /></Card>
      </div>

      {kind === 'business' && d.business && (
        <Card className="p-5 border-slate-200 bg-slate-50">
          <div className="text-sm text-slate-700"><b>For businesses:</b> {d.business}</div>
        </Card>
      )}
    </div>
  );
}
